import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { DirectoriesPageResponse } from 'types/directory/DirectoriesPageResponse';
import directoryQueryKeys from './directoryQueryKeys';

export const useDirectoriesListQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of directorys
  // - just get ALL directorys+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = directoryQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<DirectoriesPageResponse, Error>(
    queryKey,
    () =>
      sdk.directory.query.directories(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useDirectoriesListQuery;
